import { render, staticRenderFns } from "./MAPage.vue?vue&type=template&id=61b8f307&scoped=true"
import script from "./MAPage.vue?vue&type=script&lang=js"
export * from "./MAPage.vue?vue&type=script&lang=js"
import style0 from "./MAPage.vue?vue&type=style&index=0&id=61b8f307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8f307",
  null
  
)

export default component.exports